import { SendMMIInvitations } from './../../states/pro-exam/pro-exam.actions';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ProUserApplication } from '@tsin-core/states/applications/applications.model';
import { IProExam } from '@tsin-core/states/pro-exam/pro-exam.models';
import { environment } from '@tsin-env/environment';
import { map, Observable } from 'rxjs';


const PRO_BASE_URL = `${environment.apiUrl2}`;
const PRO_EXAM_URL = `${environment.apiUrl2}/exams`;
const PRO_EXAM_URL_NEW = `${environment.apiUrl2}/exams`;
const PRO_EXAM_SUPERVISOR = `${environment.apiUrl2}/supervisors`;
// const PRO_EXAM_URL = `https://pro-be-dev.tsin.ca/api/exams`;


@Injectable({
  providedIn: 'root'
})
export class ProExamService {


  private http: HttpClient = inject(HttpClient);

  // Get all exams
  getAllExams(): Observable<{ data: IProExam[] }> {
    return this.http.get<{ data: IProExam[] }>(`${PRO_EXAM_URL}/all`);
  }

  // Create a new exam
  createProExam(exam: any): Observable<any> {
    return this.http.post<any>(PRO_EXAM_URL, exam);
  }

  getSingleExamsById(id: string): Observable<any> {
    return this.http.get<any>(`${PRO_EXAM_URL_NEW}/interviewers-and-moderators/${id}`);
  }

  getSingleExamsByType(payload: { cohortId: string, type: string, isAux: boolean }): Observable<any> {
    return this.http.get<any>(`${PRO_EXAM_URL_NEW}/interviewers-and-moderators/${payload.cohortId}`, {
      params: {
        type: payload.type,
        isAuxiliary: payload.isAux
      }
    });
  }

  // POST: Create a new interviewer
  assignModeratorsCohort(moderators: any): Observable<any> {
    return this.http.post(`${PRO_EXAM_URL_NEW}/assign-moderators`, moderators);
  }

  // POST: Create a new interviewer
  assignInterviewersCohort(interviewees: any): Observable<any> {
    return this.http.post(`${PRO_EXAM_URL_NEW}/assign-interviewers`, interviewees);
  }


  // POST: Delete a interviewer
  removeInterviewerAssignment(payload: { interviewerId: string, cohortId: string }): Observable<any> {
    return this.http.request('delete', `${PRO_EXAM_SUPERVISOR}/remove-interviewer`, { body: payload });
  }

  removeModeratorAssignment(payload: { moderatorId: string, cohortId: string }): Observable<any> {
    return this.http.request('delete', `${PRO_EXAM_SUPERVISOR}/remove-moderator`, { body: payload });
  }

  // Update an existing exam
  updateProExam(exam: any): Observable<any> {
    return this.http.put<any>(PRO_EXAM_URL, exam);
  }

  // Delete an exam
  deleteProExam(id: string): Observable<any> {
    return this.http.delete<any>(`${PRO_EXAM_URL}/${id}`);
  }

  sendFinalDecisionEmail(portalDrawId: string): Observable<any> {
    return this.http.patch<any>(`${PRO_EXAM_URL}/final-decision-email/${portalDrawId}`, { portalDrawId });
  }

  sendPhase2FinalDecisionEmail(portalDrawId: string): Observable<any> {
    return this.http.patch<any>(`${PRO_EXAM_URL}/final-phase2-decision-email/${portalDrawId}`, { portalDrawId });
  }

  // Change status of an exam
  changeStatus(examId: number, newStatus: string): Observable<any> {
    return this.http.put<any>(`${PRO_EXAM_URL}/change-status`, { id: examId, status: newStatus });
  }

  // Get a single exam by ID
  getSingleExam(id: number): Observable<any> {
    return this.http.get<any>(`${PRO_EXAM_URL}/single/${id}`);
  }

  // Set exam fee (Assuming this is a GET that sets/returns a fee)
  setExamFee(id: string, fee: number): Observable<any> {
    return this.http.post<any>(`${PRO_EXAM_URL}/set-fee`, { id, fee: fee.toString() });
  }

  // Demo call (Assuming this does not require parameters)
  getDemo(): Observable<any> {
    return this.http.get<any>(`${PRO_EXAM_URL}/demo`);
  }

  getSingleSupervisor(payload: { userId: string }) {
    return this.http.get<any>(`${PRO_EXAM_SUPERVISOR}/user/${payload.userId}`);
  }

  getExamsBySession(): Observable<{ data: IProExam[] }> {
    return this.http.get<{ data: IProExam[] }>(`${PRO_BASE_URL}/pro/admin/pro-exam/sessions`);
  }

  getCompletedApplications(examId: string): Observable<{ data: ProUserApplication[] }> {
    return this.http.get<{ data: ProUserApplication[] }>(`${PRO_BASE_URL}/applications/admin/review/${examId}`);
  }

  getApplicantList(payload: { examId: string, drawId: string }): Observable<any> {
    return this.http.get<any>(`${PRO_BASE_URL}/applications/physician-apply/generate-applications-list/${payload.examId}`,
      { params: { portalDrawId: payload.drawId } }
    ).pipe(map(res => res.data));
  }

  sendPhase2Invitations(portalDrawId: string): Observable<any> {
    return this.http.patch<any>(`${PRO_BASE_URL}/application/phase2/send-phase2-invitation-emails/${portalDrawId}`, { portalDrawId });
  }

  sendMMIInvitations(portalDrawId: string): Observable<any> {
    return this.http.patch<any>(`${PRO_BASE_URL}/application/phase2/send-mmi-invitation-emails/${portalDrawId}`, { portalDrawId });
  }

  // Case type assignment
  assignCaseType(supervisorId: string, payload: { trackId: string; caseType: string }): Observable<any> {
    return this.http.put<any>(`${PRO_EXAM_SUPERVISOR}/${supervisorId}/case-type-assignment`, payload);
  }

  removeCaseType(supervisorId: string, trackId: string): Observable<any> {
    return this.http.delete<any>(`${PRO_EXAM_SUPERVISOR}/${supervisorId}/case-type-assignment/${trackId}`);
  }

  setDefaultCaseType(supervisorId: string, caseType: string): Observable<any> {
    return this.http.put<any>(`${PRO_EXAM_SUPERVISOR}/${supervisorId}/case-type`, { caseType });
  }

  clearDefaultCaseType(supervisorId: string): Observable<any> {
    return this.http.delete<any>(`${PRO_EXAM_SUPERVISOR}/${supervisorId}/case-type`);
  }
}
